export interface PromoOffer {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  badge: string;
  badgeColor: string;
  discount: string;
  color: string;
  colorSecondary: string;
  endsAt: string; // ISO date
  image: string;
  tag: string;
  code?: string;
}

export interface PromoProduct {
  id: number;
  name: string;
  description: string;
  price: number;
  oldPrice: number;
  discount: number;
  rating: number;
  reviews: number;
  color: string;
  image: string;
  category: string;
  promoTag: string;
}

export const promoOffers: PromoOffer[] = [
  {
    id: 1,
    title: 'СУПЕРСКИДКИ НА ВИТАМИНЫ',
    subtitle: 'До -40% на весь ассортимент',
    description: 'Витамины группы B, D3, Омега-3, мультивитаминные комплексы — всё по специальным ценам. Только до конца недели!',
    badge: 'ГОРЯЧЕЕ ПРЕДЛОЖЕНИЕ',
    badgeColor: '#ff2d78',
    discount: '-40%',
    color: '#ff2d78',
    colorSecondary: '#ff6b00',
    endsAt: '2026-04-12T23:59:59',
    image: 'https://public.readdy.ai/ai/img_res/521dff2d00c246884a82a1aff65c8bb7.jpg',
    tag: 'vitamins',
    code: 'VIT40',
  },
  {
    id: 2,
    title: 'НЕДЕЛЯ СЕРДЦА',
    subtitle: 'Кардиопрепараты со скидкой до -30%',
    description: 'Кардиомагнил, Аспаркам, Венарус, Троксевазин и другие препараты для здоровья сердца и сосудов.',
    badge: 'СПЕЦИАЛЬНАЯ АКЦИЯ',
    badgeColor: '#00f5ff',
    discount: '-30%',
    color: '#00f5ff',
    colorSecondary: '#39ff14',
    endsAt: '2026-04-15T23:59:59',
    image: 'https://readdy.ai/api/search-image?query=heart%20health%20cardio%20medicine%20tablets%20glowing%20cyan%20neon%20dark%20background%20cyberpunk%20pharmacy%20product%20display%20artistic%20minimal&width=800&height=420&seq=promo-banner-2&orientation=landscape',
    tag: 'cardio',
    code: 'HEART30',
  },
  {
    id: 3,
    title: 'АПТЕКА ВЫХОДНОГО ДНЯ',
    subtitle: 'Скидка 25% каждую субботу и воскресенье',
    description: 'Каждые выходные — особые цены на весь каталог. Без промокода, автоматически при оформлении заказа.',
    badge: 'КАЖДЫЕ ВЫХОДНЫЕ',
    badgeColor: '#39ff14',
    discount: '-25%',
    color: '#39ff14',
    colorSecondary: '#f0ff00',
    endsAt: '2026-04-07T23:59:59',
    image: 'https://readdy.ai/api/search-image?query=pharmacy%20weekend%20sale%20medicine%20bottles%20glowing%20green%20yellow%20neon%20dark%20background%20cyberpunk%20minimal%20artistic%20product%20display&width=800&height=420&seq=promo-banner-3&orientation=landscape',
    tag: 'weekend',
  },
];

export const promoCategories = [
  { id: 'all', label: 'Все акции', icon: 'ri-price-tag-3-line', color: '#ff2d78' },
  { id: 'vitamins', label: 'Витамины', icon: 'ri-capsule-line', color: '#ff6b00' },
  { id: 'cardio', label: 'Сердце', icon: 'ri-heart-3-line', color: '#00f5ff' },
  { id: 'pain', label: 'Обезболивающие', icon: 'ri-heart-pulse-line', color: '#39ff14' },
  { id: 'cold', label: 'Простуда', icon: 'ri-drop-line', color: '#f0ff00' },
  { id: 'stomach', label: 'ЖКТ', icon: 'ri-mental-health-line', color: '#ff2d78' },
];

export const promoProducts: PromoProduct[] = [
  {
    id: 1, name: 'Кардиомагнил 75 мг, 100 шт', description: 'Антиагрегант, профилактика тромбоза',
    price: 363, oldPrice: 480, discount: 24, rating: 4.8, reviews: 3421, color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=aspirin%20cardio%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod12&orientation=squarish',
    category: 'cardio', promoTag: 'НЕДЕЛЯ СЕРДЦА',
  },
  {
    id: 2, name: 'Аквадетрим Витамин D3, 10 мл', description: 'Витамин D3 водный раствор 15 000 МЕ/мл',
    price: 580, oldPrice: 720, discount: 19, rating: 4.9, reviews: 1024, color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod3&orientation=squarish',
    category: 'vitamins', promoTag: 'СУПЕРСКИДКИ',
  },
  {
    id: 3, name: 'Зодак Таблетки 10 мг, 30 шт', description: 'Антигистаминный препарат от аллергии',
    price: 265, oldPrice: 340, discount: 22, rating: 4.7, reviews: 2187, color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=antihistamine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=prod11&orientation=squarish',
    category: 'pain', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
  {
    id: 4, name: 'Эссенциале Форте Н 300 мг, 90 шт', description: 'Гепатопротектор, восстановление печени',
    price: 2014, oldPrice: 2600, discount: 22, rating: 4.7, reviews: 876, color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=liver%20health%20capsules%20medicine%20yellow%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20photography%20sharp%20minimal%20clean&width=400&height=400&seq=prod4&orientation=squarish',
    category: 'stomach', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
  {
    id: 5, name: 'Венарус 900+100 мг, 60 шт', description: 'Флеботоник, лечение варикоза',
    price: 3395, oldPrice: 4200, discount: 19, rating: 4.8, reviews: 712, color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=vein%20health%20medicine%20tablets%20box%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod8&orientation=squarish',
    category: 'cardio', promoTag: 'НЕДЕЛЯ СЕРДЦА',
  },
  {
    id: 6, name: 'Омега-3 Капсулы 1000 мг, 60 шт', description: 'Рыбий жир высшей очистки',
    price: 780, oldPrice: 980, discount: 20, rating: 4.7, reviews: 1432, color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=omega%203%20fish%20oil%20capsules%20bottle%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=cat-21&orientation=squarish',
    category: 'vitamins', promoTag: 'СУПЕРСКИДКИ',
  },
  {
    id: 7, name: 'Терафлю Порошок, 10 пакетов', description: 'Комплексное средство от простуды',
    price: 456, oldPrice: 580, discount: 21, rating: 4.6, reviews: 3210, color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=theraflu%20cold%20flu%20powder%20sachets%20medicine%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=cat-20&orientation=squarish',
    category: 'cold', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
  {
    id: 8, name: 'Магне B6 Таблетки, 60 шт', description: 'Магний с витамином B6',
    price: 890, oldPrice: 1100, discount: 19, rating: 4.7, reviews: 1654, color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=magnesium%20B6%20vitamin%20supplement%20tablets%20box%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=cat-17&orientation=squarish',
    category: 'vitamins', promoTag: 'СУПЕРСКИДКИ',
  },
  {
    id: 9, name: 'Нурофен Экспресс 200 мг, 16 шт', description: 'Быстродействующее обезболивающее',
    price: 312, oldPrice: 390, discount: 20, rating: 4.8, reviews: 4521, color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20capsules%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=cat-16&orientation=squarish',
    category: 'pain', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
  {
    id: 10, name: 'Троксевазин Гель 2%, 100 г', description: 'Ангиопротектор, лечение варикоза',
    price: 895, oldPrice: 1100, discount: 19, rating: 4.6, reviews: 934, color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=vein%20gel%20tube%20medicine%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=400&height=400&seq=prod9&orientation=squarish',
    category: 'cardio', promoTag: 'НЕДЕЛЯ СЕРДЦА',
  },
  {
    id: 11, name: 'Линекс Капсулы, 32 шт', description: 'Пробиотик, восстановление микрофлоры',
    price: 567, oldPrice: 720, discount: 21, rating: 4.6, reviews: 2876, color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=probiotic%20capsules%20medicine%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=400&height=400&seq=cat-18&orientation=squarish',
    category: 'stomach', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
  {
    id: 12, name: 'Лоратадин 10 мг, 30 шт', description: 'Антигистаминный, сезонная аллергия',
    price: 98, oldPrice: 140, discount: 30, rating: 4.5, reviews: 2341, color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=loratadine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=cat-15&orientation=squarish',
    category: 'cold', promoTag: 'ВЫХОДНОЙ ДЕНЬ',
  },
];

export const loyaltyBenefits = [
  { icon: 'ri-gift-line', color: '#ff2d78', title: '+500 баллов', desc: 'За первый заказ от 1 000 ₽' },
  { icon: 'ri-percent-line', color: '#00f5ff', title: 'Кэшбэк 5%', desc: 'Баллами с каждой покупки' },
  { icon: 'ri-truck-line', color: '#39ff14', title: 'Бесплатная доставка', desc: 'При заказе от 500 ₽' },
  { icon: 'ri-vip-crown-line', color: '#f0ff00', title: 'VIP-статус', desc: 'Скидка 10% при накоплении 5 000 баллов' },
];

export interface PromoCode {
  id: number;
  code: string;
  title: string;
  description: string;
  discount: string;
  discountType: 'percent' | 'fixed' | 'free_delivery';
  minOrder: number;
  expiresAt: string;
  usesLeft: number;
  usesTotal: number;
  color: string;
  icon: string;
  category: string;
  isNew?: boolean;
  isHot?: boolean;
}

export const promoCodes: PromoCode[] = [
  {
    id: 1,
    code: 'VIT40',
    title: 'Суперскидка на витамины',
    description: 'Скидка 40% на все витамины и БАД. Действует на весь ассортимент раздела «Витамины».',
    discount: '-40%',
    discountType: 'percent',
    minOrder: 500,
    expiresAt: '2026-04-12T23:59:59',
    usesLeft: 47,
    usesTotal: 200,
    color: '#ff2d78',
    icon: 'ri-capsule-line',
    category: 'Витамины и БАД',
    isHot: true,
  },
  {
    id: 2,
    code: 'HEART30',
    title: 'Неделя сердца',
    description: 'Скидка 30% на кардиопрепараты: Кардиомагнил, Аспаркам, Венарус, Троксевазин и другие.',
    discount: '-30%',
    discountType: 'percent',
    minOrder: 800,
    expiresAt: '2026-04-15T23:59:59',
    usesLeft: 83,
    usesTotal: 150,
    color: '#00f5ff',
    icon: 'ri-heart-3-line',
    category: 'Сердце и сосуды',
    isNew: false,
  },
  {
    id: 3,
    code: 'FIRST500',
    title: 'Скидка для новых клиентов',
    description: 'Скидка 500 ₽ на первый заказ. Только для новых покупателей при заказе от 1 500 ₽.',
    discount: '-500 ₽',
    discountType: 'fixed',
    minOrder: 1500,
    expiresAt: '2026-06-30T23:59:59',
    usesLeft: 312,
    usesTotal: 500,
    color: '#39ff14',
    icon: 'ri-user-add-line',
    category: 'Для новых клиентов',
    isNew: true,
  },
  {
    id: 4,
    code: 'FREERUN',
    title: 'Бесплатная доставка',
    description: 'Бесплатная доставка на любой заказ без минимальной суммы. Курьером или в пункт выдачи.',
    discount: 'Бесплатно',
    discountType: 'free_delivery',
    minOrder: 0,
    expiresAt: '2026-04-30T23:59:59',
    usesLeft: 156,
    usesTotal: 300,
    color: '#f0ff00',
    icon: 'ri-truck-line',
    category: 'Доставка',
    isNew: true,
  },
  {
    id: 5,
    code: 'COLD25',
    title: 'Сезон простуды',
    description: 'Скидка 25% на противопростудные препараты: Терафлю, Колдрекс, Ринза, Фервекс и другие.',
    discount: '-25%',
    discountType: 'percent',
    minOrder: 300,
    expiresAt: '2026-04-20T23:59:59',
    usesLeft: 201,
    usesTotal: 400,
    color: '#ff6b00',
    icon: 'ri-drop-line',
    category: 'Простуда и грипп',
    isHot: false,
  },
  {
    id: 6,
    code: 'SKIN20',
    title: 'Уход за кожей',
    description: 'Скидка 20% на косметику и средства по уходу за кожей. Кремы, сыворотки, маски.',
    discount: '-20%',
    discountType: 'percent',
    minOrder: 600,
    expiresAt: '2026-05-01T23:59:59',
    usesLeft: 89,
    usesTotal: 200,
    color: '#ff2d78',
    icon: 'ri-sparkling-line',
    category: 'Косметика',
    isNew: true,
  },
  {
    id: 7,
    code: 'BONUS2X',
    title: 'Двойные бонусы',
    description: 'Удвоенное начисление бонусных баллов на весь заказ. Баллы зачисляются в течение 24 часов.',
    discount: 'x2 баллы',
    discountType: 'percent',
    minOrder: 1000,
    expiresAt: '2026-04-10T23:59:59',
    usesLeft: 34,
    usesTotal: 100,
    color: '#f0ff00',
    icon: 'ri-vip-crown-line',
    category: 'Бонусная программа',
    isHot: true,
  },
  {
    id: 8,
    code: 'STOMACH15',
    title: 'Здоровье ЖКТ',
    description: 'Скидка 15% на препараты для пищеварения: Эссенциале, Линекс, Мезим, Омепразол и другие.',
    discount: '-15%',
    discountType: 'percent',
    minOrder: 400,
    expiresAt: '2026-04-25T23:59:59',
    usesLeft: 178,
    usesTotal: 250,
    color: '#39ff14',
    icon: 'ri-mental-health-line',
    category: 'Пищеварение',
    isNew: false,
  },
];

export interface PromoDetailProduct {
  id: number;
  name: string;
  description: string;
  price: number;
  oldPrice: number;
  discount: number;
  rating: number;
  reviews: number;
  image: string;
  category: string;
  inStock: boolean;
}

export const promoDetailProducts: Record<number, PromoDetailProduct[]> = {
  1: [
    {
      id: 101, name: 'Аквадетрим Витамин D3, 10 мл', description: 'Водный раствор витамина D3 15 000 МЕ/мл',
      price: 580, oldPrice: 720, discount: 19, rating: 4.9, reviews: 1024,
      image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-101&orientation=squarish',
      category: 'Витамин D', inStock: true,
    },
    {
      id: 102, name: 'Омега-3 Капсулы 1000 мг, 60 шт', description: 'Рыбий жир высшей очистки, EPA+DHA',
      price: 780, oldPrice: 980, discount: 20, rating: 4.7, reviews: 1432,
      image: 'https://readdy.ai/api/search-image?query=omega%203%20fish%20oil%20capsules%20bottle%20golden%20yellow%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-102&orientation=squarish',
      category: 'Омега-3', inStock: true,
    },
    {
      id: 103, name: 'Магне B6 Таблетки, 60 шт', description: 'Магний с витамином B6 для нервной системы',
      price: 890, oldPrice: 1100, discount: 19, rating: 4.7, reviews: 1654,
      image: 'https://readdy.ai/api/search-image?query=magnesium%20B6%20vitamin%20supplement%20tablets%20box%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-103&orientation=squarish',
      category: 'Витамин B', inStock: true,
    },
    {
      id: 104, name: 'Витамин C 1000 мг, 30 шт', description: 'Аскорбиновая кислота с шиповником',
      price: 340, oldPrice: 420, discount: 19, rating: 4.8, reviews: 2341,
      image: 'https://readdy.ai/api/search-image?query=vitamin%20C%20ascorbic%20acid%20tablets%20orange%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-104&orientation=squarish',
      category: 'Витамин C', inStock: true,
    },
    {
      id: 105, name: 'Мультитабс Иммуно Плюс, 30 шт', description: 'Мультивитаминный комплекс с цинком',
      price: 650, oldPrice: 820, discount: 21, rating: 4.6, reviews: 876,
      image: 'https://readdy.ai/api/search-image?query=multivitamin%20complex%20tablets%20bottle%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-105&orientation=squarish',
      category: 'Мультивитамины', inStock: true,
    },
    {
      id: 106, name: 'Витамин E 400 МЕ, 30 капсул', description: 'Токоферол, антиоксидант',
      price: 290, oldPrice: 360, discount: 19, rating: 4.5, reviews: 543,
      image: 'https://readdy.ai/api/search-image?query=vitamin%20E%20tocopherol%20capsules%20bottle%20yellow%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-106&orientation=squarish',
      category: 'Витамин E', inStock: false,
    },
    {
      id: 107, name: 'Цинк Хелат 25 мг, 60 шт', description: 'Органический цинк для иммунитета',
      price: 420, oldPrice: 530, discount: 21, rating: 4.6, reviews: 712,
      image: 'https://readdy.ai/api/search-image?query=zinc%20supplement%20capsules%20bottle%20green%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-107&orientation=squarish',
      category: 'Минералы', inStock: true,
    },
    {
      id: 108, name: 'Фолиевая кислота 400 мкг, 90 шт', description: 'Витамин B9, для беременных',
      price: 180, oldPrice: 230, discount: 22, rating: 4.8, reviews: 1987,
      image: 'https://readdy.ai/api/search-image?query=folic%20acid%20vitamin%20B9%20tablets%20small%20bottle%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-108&orientation=squarish',
      category: 'Витамин B', inStock: true,
    },
  ],
  2: [
    {
      id: 201, name: 'Кардиомагнил 75 мг, 100 шт', description: 'Антиагрегант, профилактика тромбоза',
      price: 363, oldPrice: 480, discount: 24, rating: 4.8, reviews: 3421,
      image: 'https://readdy.ai/api/search-image?query=aspirin%20cardio%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-201&orientation=squarish',
      category: 'Антиагреганты', inStock: true,
    },
    {
      id: 202, name: 'Аспаркам Таблетки, 56 шт', description: 'Препарат калия и магния для сердца',
      price: 98, oldPrice: 140, discount: 30, rating: 4.7, reviews: 2187,
      image: 'https://readdy.ai/api/search-image?query=potassium%20magnesium%20heart%20medicine%20tablets%20blister%20pack%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-202&orientation=squarish',
      category: 'Препараты магния', inStock: true,
    },
    {
      id: 203, name: 'Венарус 900+100 мг, 60 шт', description: 'Флеботоник, лечение варикоза',
      price: 3395, oldPrice: 4200, discount: 19, rating: 4.8, reviews: 712,
      image: 'https://readdy.ai/api/search-image?query=vein%20health%20medicine%20tablets%20box%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-203&orientation=squarish',
      category: 'Флеботоники', inStock: true,
    },
    {
      id: 204, name: 'Троксевазин Гель 2%, 100 г', description: 'Ангиопротектор, лечение варикоза',
      price: 895, oldPrice: 1100, discount: 19, rating: 4.6, reviews: 934,
      image: 'https://readdy.ai/api/search-image?query=vein%20gel%20tube%20medicine%20green%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=400&height=400&seq=pd-204&orientation=squarish',
      category: 'Ангиопротекторы', inStock: true,
    },
    {
      id: 205, name: 'Детралекс 500 мг, 60 шт', description: 'Флеботоник, хроническая венозная недостаточность',
      price: 2890, oldPrice: 3600, discount: 20, rating: 4.9, reviews: 1543,
      image: 'https://readdy.ai/api/search-image?query=diosmin%20vein%20medicine%20tablets%20box%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-205&orientation=squarish',
      category: 'Флеботоники', inStock: true,
    },
    {
      id: 206, name: 'Магнерот 500 мг, 50 шт', description: 'Магния оротат, нарушения ритма сердца',
      price: 560, oldPrice: 700, discount: 20, rating: 4.5, reviews: 432,
      image: 'https://readdy.ai/api/search-image?query=magnesium%20orotate%20heart%20medicine%20tablets%20box%20green%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-206&orientation=squarish',
      category: 'Препараты магния', inStock: false,
    },
  ],
  3: [
    {
      id: 301, name: 'Нурофен Экспресс 200 мг, 16 шт', description: 'Быстродействующее обезболивающее',
      price: 312, oldPrice: 390, discount: 20, rating: 4.8, reviews: 4521,
      image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20capsules%20blister%20pack%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-301&orientation=squarish',
      category: 'Обезболивающие', inStock: true,
    },
    {
      id: 302, name: 'Терафлю Порошок, 10 пакетов', description: 'Комплексное средство от простуды',
      price: 456, oldPrice: 580, discount: 21, rating: 4.6, reviews: 3210,
      image: 'https://readdy.ai/api/search-image?query=theraflu%20cold%20flu%20powder%20sachets%20medicine%20yellow%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-302&orientation=squarish',
      category: 'Простуда', inStock: true,
    },
    {
      id: 303, name: 'Зодак Таблетки 10 мг, 30 шт', description: 'Антигистаминный препарат от аллергии',
      price: 265, oldPrice: 340, discount: 22, rating: 4.7, reviews: 2187,
      image: 'https://readdy.ai/api/search-image?query=antihistamine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-303&orientation=squarish',
      category: 'Аллергия', inStock: true,
    },
    {
      id: 304, name: 'Эссенциале Форте Н 300 мг, 90 шт', description: 'Гепатопротектор, восстановление печени',
      price: 2014, oldPrice: 2600, discount: 22, rating: 4.7, reviews: 876,
      image: 'https://readdy.ai/api/search-image?query=liver%20health%20capsules%20medicine%20yellow%20orange%20neon%20glow%20dark%20background%20pharmacy%20product%20photography%20sharp%20minimal%20clean&width=400&height=400&seq=pd-304&orientation=squarish',
      category: 'ЖКТ', inStock: true,
    },
    {
      id: 305, name: 'Линекс Капсулы, 32 шт', description: 'Пробиотик, восстановление микрофлоры',
      price: 567, oldPrice: 720, discount: 21, rating: 4.6, reviews: 2876,
      image: 'https://readdy.ai/api/search-image?query=probiotic%20capsules%20medicine%20green%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=400&height=400&seq=pd-305&orientation=squarish',
      category: 'Пробиотики', inStock: true,
    },
    {
      id: 306, name: 'Лоратадин 10 мг, 30 шт', description: 'Антигистаминный, сезонная аллергия',
      price: 98, oldPrice: 140, discount: 30, rating: 4.5, reviews: 2341,
      image: 'https://readdy.ai/api/search-image?query=loratadine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-306&orientation=squarish',
      category: 'Аллергия', inStock: true,
    },
    {
      id: 307, name: 'Колдрекс Хотрем, 10 пакетов', description: 'Горячий напиток от простуды и гриппа',
      price: 380, oldPrice: 480, discount: 21, rating: 4.5, reviews: 1876,
      image: 'https://readdy.ai/api/search-image?query=coldrex%20hot%20drink%20cold%20flu%20powder%20sachets%20medicine%20orange%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-307&orientation=squarish',
      category: 'Простуда', inStock: true,
    },
    {
      id: 308, name: 'Мезим Форте 10000, 20 шт', description: 'Ферментный препарат для пищеварения',
      price: 245, oldPrice: 310, discount: 21, rating: 4.6, reviews: 3102,
      image: 'https://readdy.ai/api/search-image?query=mezim%20enzyme%20digestive%20medicine%20tablets%20blister%20pack%20green%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=pd-308&orientation=squarish',
      category: 'ЖКТ', inStock: false,
    },
    {
      id: 309, name: 'Пантенол Спрей 130 г', description: 'Регенерирующее средство для кожи',
      price: 420, oldPrice: 530, discount: 21, rating: 4.7, reviews: 1234,
      image: 'https://readdy.ai/api/search-image?query=panthenol%20spray%20skin%20care%20medicine%20bottle%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=pd-309&orientation=squarish',
      category: 'Кожа', inStock: true,
    },
  ],
};

export interface FlashDeal {
  id: number;
  name: string;
  price: number;
  oldPrice: number;
  discount: number;
  endsAt: string;
  image: string;
  color: string;
  stock: number;
  sold: number;
}

export const flashDeals: FlashDeal[] = [
  {
    id: 1,
    name: 'Нурофен Экспресс 200 мг × 16',
    price: 199,
    oldPrice: 390,
    discount: 49,
    endsAt: '2026-04-05T20:00:00',
    image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20capsules%20blister%20pack%20pink%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=flash1&orientation=squarish',
    color: '#ff2d78',
    stock: 50,
    sold: 38,
  },
  {
    id: 2,
    name: 'Аквадетрим Витамин D3 10 мл',
    price: 390,
    oldPrice: 720,
    discount: 46,
    endsAt: '2026-04-05T22:00:00',
    image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal&width=400&height=400&seq=flash2&orientation=squarish',
    color: '#00f5ff',
    stock: 30,
    sold: 21,
  },
  {
    id: 3,
    name: 'Омега-3 1000 мг × 60 капсул',
    price: 490,
    oldPrice: 980,
    discount: 50,
    endsAt: '2026-04-06T10:00:00',
    image: 'https://readdy.ai/api/search-image?query=omega%203%20fish%20oil%20capsules%20bottle%20golden%20neon%20glow%20dark%20background%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=flash3&orientation=squarish',
    color: '#f0ff00',
    stock: 40,
    sold: 17,
  },
];
